import { render, staticRenderFns } from "./DashboardDevice.vue?vue&type=template&id=422817f9&"
import script from "./DashboardDevice.vue?vue&type=script&lang=js&"
export * from "./DashboardDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports